import PageLayout from './PageLayout.container';

export default PageLayout;
